"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2026],{

/***/ 6629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7379);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6643);
/* harmony import */ var _buttons_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8163);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3887);


// components


// styles

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 52px;\n  padding: 0 24px;\n  border-bottom: 1px solid ",
        ";\n  background-color: ",
        ";\n  font-size: 14px;\n  border-radius: 0;\n\n  ",
        " {\n    border-bottom: 1px solid ",
        ";\n  }\n  & > svg {\n    flex-shrink: 0;\n  }\n\n  & > span {\n    line-height: 20px;\n    font-weight: 500;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
/**
 * Bottom Sheet 체크 버튼
 *
 * @example
 * import BottomSheet from 'cds/bottomsheet';
 * import CheckButton from 'cds/bottomsheet/buttons/Check';
 *
 * <BottomSheet>
 *   <CheckButton message="참여인기순" checked />
 *   <CheckButton message="별점높은순" />
 *   <CheckButton message="리뷰많은순" />
 *   <CheckButton message="가격낮은순" />
 *   <CheckButton message="가격높은순" />
 *   <CheckButton message="최신순" />
 * </BottomSheet>
 */ var CheckButton = function(_param) {
    var checked = _param.checked, message = _param.message, props = _objectWithoutProperties(_param, [
        "checked",
        "message"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Button, _objectSpread({}, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: message
            }),
            checked && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                name: "ic_check",
                stroke: _styles__WEBPACK_IMPORTED_MODULE_3__/* .palette.grey50 */ .DG.grey50,
                width: 16,
                height: 16
            })
        ]
    })));
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_buttons_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-f006352c-0"
})(_templateObject(), _styles__WEBPACK_IMPORTED_MODULE_3__/* .palette.system.BNB */ .DG.system.BNB, _styles__WEBPACK_IMPORTED_MODULE_3__/* .palette.system.BNB */ .DG.system.BNB, _styles__WEBPACK_IMPORTED_MODULE_3__/* .mediaQuery.large */ .cy.large, _styles__WEBPACK_IMPORTED_MODULE_3__/* .palette.system.grey */ .DG.system.grey, _styles__WEBPACK_IMPORTED_MODULE_3__/* .palette.grey50 */ .DG.grey50);
/* harmony default export */ __webpack_exports__["Z"] = (CheckButton);


/***/ }),

/***/ 5064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ bottomsheet; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(3935);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
;// CONCATENATED MODULE: ./src/cds/bottomsheet/Background.tsx

// styles

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n\tfrom { opacity: 0; }\n\tto { opacity 1; }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n\tfrom { opacity: 1; }\n\tto { opacity 0; }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        animation: ",
        " 0.1s;\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n        animation: ",
        " 0.1s;\n      "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100vw;\n  background-color: ",
        ";\n  z-index: ",
        ";\n  overflow: hidden;\n  ",
        ";\n  animation-fill-mode: forwards;\n\n  ",
        " {\n    display: none;\n  }\n\n  &:after {\n    content: '';\n    min-height: inherit;\n    font-size: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var AnimeFadeIn = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var AnimeFadeOut = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var Background = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6c769949-0"
})(_templateObject4(), styles/* palette.dim.basic */.DG.dim.basic, styles/* zIndex.modal */.W5.modal, function(param) {
    var animated = param.animated;
    if (animated === 'OPEN') {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), AnimeFadeIn);
    }
    if (animated === 'CLOSE') {
        return (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), AnimeFadeOut);
    }
}, styles/* mediaQuery.large */.cy.large);
/* harmony default export */ var bottomsheet_Background = (Background);

;// CONCATENATED MODULE: ./src/cds/bottomsheet/Header.tsx

// styles

function Header_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Header_templateObject() {
    var data = Header_taggedTemplateLiteral([
        "\n  width: 48px;\n  height: 4px;\n  border-radius: 4px;\n  background-color: ",
        ";\n  margin: 12px auto;\n"
    ]);
    Header_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a028b51-0"
})(Header_templateObject(), styles/* palette.grey030 */.DG.grey030);
/* harmony default export */ var bottomsheet_Header = (Header);

;// CONCATENATED MODULE: ./src/cds/bottomsheet/Sheet.tsx



// components

// styles

function Sheet_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Sheet_templateObject() {
    var data = Sheet_taggedTemplateLiteral([
        "\n\tfrom { transform: translateY(100%); }\n\tto { transform: translateY(0%); }\n"
    ]);
    Sheet_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Sheet_templateObject1() {
    var data = Sheet_taggedTemplateLiteral([
        "\n\tfrom { transform: translateY(0%); }\n\tto { transform: translateY(100%); }\n"
    ]);
    Sheet_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Sheet_templateObject2() {
    var data = Sheet_taggedTemplateLiteral([
        "\n        animation: ",
        " ",
        "ms;\n      "
    ]);
    Sheet_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Sheet_templateObject3() {
    var data = Sheet_taggedTemplateLiteral([
        "\n        animation: ",
        " ",
        "ms;\n      "
    ]);
    Sheet_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Sheet_templateObject4() {
    var data = Sheet_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding-bottom: 0;\n  padding-bottom: calc(constant(safe-area-inset-bottom));\n  padding-bottom: calc(env(safe-area-inset-bottom));\n  border-radius: 16px 16px 0 0;\n  background-color: ",
        ";\n  transition: ",
        ";\n  ",
        "\n  animation-fill-mode: forwards;\n"
    ]);
    Sheet_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
/**
 * Bottom Sheet
 * @param props
 * @param props.animated 애니메이션 상태
 * @param props.duration 애니메이션 duration 시간(단위: second)
 * @param props.onClose
 */ var Sheet = function(param) {
    var animated = param.animated, duration = param.duration, onClose = param.onClose, children = param.children;
    var ref1 = (0,react.useState)(false), isClose = ref1[0], setIsClose = ref1[1];
    var sheet = (0,react.useRef)(null);
    var startY = (0,react.useRef)(0);
    var prevY = (0,react.useRef)(0);
    var currentY = (0,react.useRef)(0);
    var direction = (0,react.useRef)('UP');
    var onPreventClose = function(e) {
        return e.stopPropagation();
    };
    var onTouchMove = function(e) {
        if (e.cancelable) {
            e.preventDefault();
        }
        prevY.current = currentY.current;
        currentY.current = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;
        var offsetDiff = currentY.current - startY.current;
        if (offsetDiff > 0) {
            sheet.current.style.transition = "transform 0s";
            sheet.current.style.transform = "translateY(".concat(offsetDiff, "px)");
        }
        var directionDiff = currentY.current - prevY.current;
        if (directionDiff > 0) {
            direction.current = 'DOWN';
        } else {
            direction.current = 'UP';
        }
    };
    var onTouchStart = (0,react.useCallback)(function(e) {
        startY.current = currentY.current = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;
        e.currentTarget.addEventListener('touchmove', onTouchMove);
        e.currentTarget.addEventListener('mousemove', onTouchMove);
    }, []);
    var onTouchEnd = (0,react.useCallback)(function(e) {
        e.currentTarget.removeEventListener('touchmove', onTouchMove);
        e.currentTarget.removeEventListener('mousemove', onTouchMove);
        var ref = sheet.current.getBoundingClientRect(), sheetHeight = ref.height;
        var offsetDiff = currentY.current - startY.current;
        sheet.current.style.transition = '';
        if (offsetDiff >= sheetHeight / 3 && direction.current === 'DOWN') {
            sheet.current.style.transform = "translateY(100%)";
            setIsClose(true);
        } else {
            sheet.current.style.transform = "translateY(0px)";
        }
    }, []);
    (0,react.useEffect)(function() {
        var sheetRef = sheet.current;
        sheetRef.addEventListener('touchstart', onTouchStart);
        sheetRef.addEventListener('touchend', onTouchEnd);
        sheetRef.addEventListener('mousedown', onTouchStart);
        sheetRef.addEventListener('mouseup', onTouchEnd);
        return function() {
            sheetRef.removeEventListener('touchstart', onTouchStart);
            sheetRef.removeEventListener('touchend', onTouchEnd);
            sheetRef.removeEventListener('mousedown', onTouchStart);
            sheetRef.removeEventListener('mouseup', onTouchEnd);
        };
    }, [
        onTouchStart,
        onTouchEnd
    ]);
    (0,react.useEffect)(function() {
        var timer = null;
        if (isClose) {
            timer = window.setTimeout(function() {
                return onClose();
            }, duration);
        }
        return function() {
            return window.clearTimeout(timer);
        };
    }, [
        isClose,
        onClose,
        duration
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        onMouseDown: onPreventClose,
        animated: animated,
        duration: duration,
        ref: sheet,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomsheet_Header, {}),
            children
        ]
    }));
};
var AnimeSlideInBottom = (0,styled_components_browser_esm/* keyframes */.F4)(Sheet_templateObject());
var AnimeSlideOutBottom = (0,styled_components_browser_esm/* keyframes */.F4)(Sheet_templateObject1());
var Wrapper = styled_components_browser_esm/* default.dialog.withConfig */.ZP.dialog.withConfig({
    componentId: "sc-9fecfb23-0"
})(Sheet_templateObject4(), styles/* palette.system.BNB */.DG.system.BNB, function(param) {
    var duration = param.duration;
    return "transform ".concat(duration, "ms ease");
}, function(param) {
    var animated = param.animated, duration = param.duration;
    if (animated === 'OPEN') {
        return (0,styled_components_browser_esm/* css */.iv)(Sheet_templateObject2(), AnimeSlideInBottom, duration);
    } else if (animated === 'CLOSE') {
        return (0,styled_components_browser_esm/* css */.iv)(Sheet_templateObject3(), AnimeSlideOutBottom, duration);
    } else {
        return '';
    }
});
/* harmony default export */ var bottomsheet_Sheet = (Sheet);

;// CONCATENATED MODULE: ./src/cds/bottomsheet/index.tsx



// components


// styles

/**
 * Bottom Sheet
 * - closeCallback: Sheet가 완전히 닫혔을 때, 콜백함수
 *
 * @example
 * // 앱 최상단에 아래와 같이 Portal 위치지정자 태그가 필요합니다.
 * <div id="cds-bottomsheet" />
 *
 * // 다음과 같이 사용해주세요.
 * const Example = () => {
 *   const [show, setShow] = useState(false);
 *
 *   const onToggle = () => setShow(v => !v);
 *
 *   return (
 *     <>
 *       <button onClick={onToggle}>BottomSheet 열기</button>
 *       {show && (
 *         <BottomSheet closeCallback={onToggle}>
 *           <h1>메뉴</h1>
 *           <p>옵션1</p>
 *           <p>옵션2</p>
 *           <p>옵션3</p>
 *         </BottomSheet>
 *       )}
 *     </>
 *   );
 * };
 */ var BottomSheet = function(param) {
    var closeCallback = param.closeCallback, children = param.children;
    /** Bottom sheet 애니메이션 duration 시간 */ var ANIME_DURATION = 200;
    var ref = (0,react.useState)("object" !== 'undefined'), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)('OPEN'), animated = ref1[0], setAnimated = ref1[1];
    var onCloseWithAnime = function(e) {
        e.preventDefault();
        setAnimated('CLOSE');
    };
    var onClose = function() {
        setShow(false);
        closeCallback && closeCallback();
    };
    /** Bottomsheet on/off 여부 */ (0,react.useEffect)(function() {
        var timer = null;
        if (animated === 'OPEN') {
            timer = window.setTimeout(function() {
                return setAnimated('NONE');
            }, ANIME_DURATION);
        } else if (animated === 'CLOSE') {
            timer = window.setTimeout(function() {
                setShow(false);
                closeCallback && closeCallback();
            }, ANIME_DURATION);
        }
        return function() {
            return window.clearTimeout(timer);
        };
    }, [
        animated,
        closeCallback
    ]);
    (0,react.useEffect)(function() {
        var enableDocumentScrolled = function() {
            document.querySelector('html').removeAttribute('style');
            document.querySelector('body').removeAttribute('style');
        };
        var disableDocumentScrolled = function() {
            document.querySelector('html').style.position = 'relative';
            document.querySelector('html').style.overflowY = 'hidden';
            document.querySelector('body').style.position = 'relative';
        };
        if (show && window.innerWidth < styles/* mediaValue.large */.T8.large) {
            disableDocumentScrolled();
        } else {
            enableDocumentScrolled();
        }
        return function() {
            return enableDocumentScrolled();
        };
    }, [
        show
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: show && /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomsheet_Background, {
                animated: animated,
                onMouseDown: onCloseWithAnime,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomsheet_Sheet, {
                    animated: animated,
                    duration: ANIME_DURATION,
                    onClose: onClose,
                    children: children
                })
            })
        })
    }));
};
var Portal = function(param) {
    var children = param.children;
    var destination = document.getElementById('cds-bottomsheet');
    return(/*#__PURE__*/ react_dom.createPortal(children, destination));
};
/* harmony default export */ var bottomsheet = (BottomSheet);


/***/ }),

/***/ 2026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useFilter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/cds/bottomsheet/index.tsx + 3 modules
var bottomsheet = __webpack_require__(5064);
// EXTERNAL MODULE: ./src/cds/bottomsheet/buttons/Check.tsx
var Check = __webpack_require__(6629);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(7379);
// EXTERNAL MODULE: ./src/cds/icons/index.tsx
var icons = __webpack_require__(6643);
// EXTERNAL MODULE: ./src/cds/buttons/Outline.tsx
var Outline = __webpack_require__(5472);
// EXTERNAL MODULE: ./src/cds/buttons/Text.tsx
var Text = __webpack_require__(8163);
// EXTERNAL MODULE: ./src/cds/styles.ts
var styles = __webpack_require__(3887);
// EXTERNAL MODULE: ./src/cds/typography.ts
var typography = __webpack_require__(506);
// EXTERNAL MODULE: ./src/lib/utils/format/time.js
var time = __webpack_require__(508);
;// CONCATENATED MODULE: ./src/components/atoms/forms/FilterDropdown.js



// components



// styles



function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  position: relative;\n  width: 132px;\n\n  ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 0;\n  width: 124px;\n  height: 40px;\n  padding: 0 8px 0 16px;\n  margin-left: 8px;\n  ",
        "\n  color: ",
        ";\n  background-color: ",
        ";\n  border: none !important;\n  & svg {\n    margin-left: 2px;\n    transform: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  width: calc(100% - 8px);\n  top: calc(100% + 2px);\n  right: 0;\n  border: none;\n  border-radius: 4px;\n  overflow: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  font-size: 14px;\n  border-radius: 0;\n  ",
        "\n  color: ",
        ";\n  background-color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
/**
 * 드롭다운
 * @param {object} props
 * @param {string} props.sortName
 * @param {string[]} props.itemList
 * @param {(name: string) => void} props.onClickItem
 *
 * @examples
 * <Dropdown sortName='최신순' itemList={['최신순', '인기순', '가격순']} />
 */ var FilterDropdown = function(param) {
    var _sortName = param.sortName, sortName = _sortName === void 0 ? '' : _sortName, itemList = param.itemList, onClickItem = param.onClickItem;
    var ref = (0,react.useState)(false), isShow = ref[0], setIsShow = ref[1];
    var ref1 = (0,react.useState)(sortName), displayItem = ref1[0], setDisplayItem = ref1[1];
    var target = (0,react.useRef)(null);
    var onSelectItem = function(item) {
        setIsShow(false);
        setDisplayItem(item);
        onClickItem(item);
    };
    var onClose = (0,react.useCallback)(function(e) {
        var path = e.path || e.composedPath && e.composedPath();
        if (!path.includes(target.current)) {
            setIsShow(false);
        }
    }, []);
    var onToggleDialog = function(e) {
        setIsShow(function(v) {
            return !v;
        });
        onClickLayout(e);
    };
    (0,react.useEffect)(function() {
        if (isShow) {
            document.addEventListener('click', onClose);
        }
        return function() {
            return document.removeEventListener('click', onClose);
        };
    }, [
        isShow,
        onClose,
        sortName
    ]);
    (0,react.useEffect)(function() {
        return setDisplayItem(sortName);
    }, [
        sortName
    ]);
    (0,react.useEffect)(function() {
        return setDisplayItem(sortName);
    }, [
        sortName
    ]);
    var filteredList = itemList.filter(function(v) {
        return v !== displayItem;
    });
    var FilteredList = filteredList.map(function(item) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(UnSelectedButton, {
            size: "Regular",
            onClick: function() {
                return onSelectItem(item);
            },
            children: item
        }, item);
    });
    // Data Mining을 위한 클릭 로직 추가
    var onClickLayout = function(e) {
        var text = e.target.textContent;
        var sort = sessionStorage.getItem('filterTypes');
        if (!sort) {
            sessionStorage.setItem('filterTypes', JSON.stringify([
                {
                    text: text,
                    timeStamp: (0,time/* getKoreaDate */.jw)()
                }, 
            ]));
            return;
        }
        if (sort !== null) {
            sort = JSON.parse(sort);
            if (sort[sort.length - 1].text !== text) {
                sort.push({
                    text: text,
                    timeStamp: (0,time/* getKoreaDate */.jw)()
                });
                sessionStorage.setItem('filterTypes', JSON.stringify(sort));
            }
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout, {
        ref: target,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectedButton, {
                onClick: function(e) {
                    onToggleDialog(e);
                },
                isShow: isShow,
                children: [
                    displayItem,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* default */.Z, {
                        name: "ic_arrow_down_r",
                        fill: styles/* palette.grey50 */.DG.grey50,
                        width: 24,
                        height: 24
                    })
                ]
            }),
            isShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog, {
                children: FilteredList
            })
        ]
    }));
};
var Layout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3ab2112-0"
})(_templateObject(), styles/* mediaQuery.large */.cy.large);
var SelectedButton = (0,styled_components_browser_esm/* default */.ZP)(Outline/* default */.Z).withConfig({
    componentId: "sc-f3ab2112-1"
})(_templateObject1(), typography/* body3_regular */.PD, styles/* palette.grey50 */.DG.grey50, styles/* palette.BTN.BG */.DG.BTN.BG, function(param) {
    var isShow = param.isShow;
    return isShow ? "rotate(180deg)" : 'rotate(0deg)';
});
var Dialog = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f3ab2112-2"
})(_templateObject2());
var UnSelectedButton = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-f3ab2112-3"
})(_templateObject3(), typography/* body3_regular */.PD, styles/* palette.grey50 */.DG.grey50, styles/* palette.system.BNB */.DG.system.BNB);
/* harmony default export */ var forms_FilterDropdown = (FilterDropdown);

;// CONCATENATED MODULE: ./src/hooks/domain/class/useFilter.js


// components



function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**@type {Array<{id:number;name:string;sort:string;order:'desc'|'asc'}>} */ var filterMap = [
    {
        id: 0,
        name: '참여인기순',
        sort: 'signup_cnt',
        order: 'desc'
    },
    {
        id: 1,
        name: '별점높은순',
        sort: 'review_score',
        order: 'desc'
    },
    {
        id: 2,
        name: '리뷰많은순',
        sort: 'review_count',
        order: 'desc'
    },
    {
        id: 3,
        name: '가격낮은순',
        sort: 'payment',
        order: 'asc'
    },
    {
        id: 4,
        name: '가격높은순',
        sort: 'payment',
        order: 'desc'
    },
    {
        id: 5,
        name: '최신순',
        sort: 'class_id',
        order: 'desc'
    },
    {
        id: 6,
        name: '정확도순',
        sort: 'match_score',
        order: 'desc'
    },
    {
        id: 7,
        name: '인기순',
        sort: 'helpful_cnt',
        order: 'desc'
    },
    {
        id: 8,
        name: '신규 등록',
        sort: 'event',
        order: 'desc'
    },
    {
        id: 9,
        name: '마감 임박',
        sort: 'event',
        order: 'asc'
    }, 
];
/**
 * 클래스 목록 필터 Hook
 * - 순서를 지정하지 않거나, 빈 배열이면 전체 정렬 리스트가 표시됩니다.
 * @param {number[]} orders 순서
 * @example
 * const {
 * 	currentFilter,
 * 	FilterSheet,
 * 	onFilterShow,
 * 	onFilterHide
 * } = useClassFilter();
 */ var useClassFilter = function() {
    var orders = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ref2 = (0,react.useState)(false), show = ref2[0], setShow = ref2[1];
    var ref1 = (0,react.useState)(orders.length === 0 ? filterMap[0] : filterMap[orders[0]]), filter = ref1[0], setFilter = ref1[1];
    var onClick = function(index) {
        setFilter(filterMap[index]);
        setShow(false);
    };
    var onClickByName = function(name) {
        var ref = _slicedToArray(filterMap.filter(function(v) {
            return v.name === name;
        }), 1), filtered = ref[0];
        if (!filtered) {
            return;
        }
        setFilter(filtered);
        setShow(false);
    };
    var ButtonList = orders.length === 0 ? filterMap.map(function(order) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Check/* default */.Z, {
            message: order.name,
            checked: filter.id === order.id,
            onClick: function() {
                return onClick(order.id);
            }
        }, order.id);
    }) : orders.map(function(id) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(Check/* default */.Z, {
            message: filterMap[id].name,
            checked: filter.id === id,
            onClick: function() {
                return onClick(id);
            }
        }, id);
    });
    var orderedFilter = orders.length === 0 ? filterMap.map(function(order) {
        return order.name;
    }) : orders.map(function(id) {
        return filterMap[id].name;
    });
    var FilterSheet = function() {
        return show ? /*#__PURE__*/ (0,jsx_runtime.jsx)(bottomsheet/* default */.Z, {
            closeCallback: function() {
                return setShow(false);
            },
            children: ButtonList
        }) : null;
    };
    var FilterDropDown = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(forms_FilterDropdown, {
            sortName: filter.name,
            itemList: orderedFilter,
            onClickItem: onClickByName
        });
    };
    return {
        currentFilter: filter,
        FilterSheet: FilterSheet,
        FilterDropdown: FilterDropDown,
        onFilterShow: function() {
            return setShow(true);
        },
        onFilterHide: function() {
            return setShow(false);
        }
    };
};
/* harmony default export */ var useFilter = (useClassFilter);


/***/ })

}]);